export default "__VITE_ASSET__DG3d1$tv__"